import { ILoadableWrapper } from '../../models/index';
import { ISensor } from '../../models/sensor.interface';
import { IStatistic } from './site.state';

export function sortSensorsByStatistics(
  sensorItems: ReadonlyArray<ILoadableWrapper<ISensor>>,
  statsMap: { [key: string]: IStatistic }
): ILoadableWrapper<ISensor>[] {
  return [...sensorItems].sort((wrapperA, wrapperB) => {
    const idA = wrapperA.id ?? '';
    const idB = wrapperB.id ?? '';

    const statsA = idA && statsMap[idA] ? statsMap[idA] : null;
    const statsB = idB && statsMap[idB] ? statsMap[idB] : null;

    const alerts24hA = statsA?.number_of_alerts_past_24hrs ?? 0;
    const alerts24hB = statsB?.number_of_alerts_past_24hrs ?? 0;
    const alertsWeekA = statsA?.number_of_alerts_this_week ?? 0;
    const alertsWeekB = statsB?.number_of_alerts_this_week ?? 0;

    if (alerts24hA !== alerts24hB) {
      return alerts24hB - alerts24hA;
    }

    return alertsWeekB - alertsWeekA;
  });
}
